import React from "react";
import {
  View,
  ScrollView,
  TouchableOpacity,
  Text,
  StyleSheet,
} from "react-native";
import Animated, { FadeIn, FadeOut, Layout } from "react-native-reanimated";

interface Product {
  id_product: number;
  name: string;
  price_sell: string;
  price_bought: string;
  stock: number;
}

interface ProductListProps {
  selectedProduct: Product[];
  selectedTag: number | null;
  setSelectedTag: (id: number) => void;
  quantities: { [key: number]: number };
  removeTag: (index: number) => void;
}

const ProductList: React.FC<ProductListProps> = ({
  selectedProduct,
  selectedTag,
  setSelectedTag,
  quantities,
  removeTag,
}) => {
  if (selectedProduct.length === 0) {
    return null;
  }

  return (
    <Animated.View
      entering={FadeIn.duration(300)}
      exiting={FadeOut.duration(200)}
      style={styles.container}
    >
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.scrollContent}
        style={styles.scrollView}
      >
        {selectedProduct.map((item, index) => (
          <Animated.View
            key={item.id_product}
            entering={FadeIn.delay(index * 50).duration(200)}
            layout={Layout.springify()}
          >
            <TouchableOpacity
              onPress={() => setSelectedTag(item.id_product)}
              style={[
                styles.productPill,
                {
                  backgroundColor:
                    selectedTag === item.id_product ? "#E3F2FD" : "#F5F5F5",
                  borderColor:
                    selectedTag === item.id_product ? "#1976D2" : "#E0E0E0",
                },
              ]}
            >
              <TouchableOpacity
                onPress={() => removeTag(index)}
                style={styles.closeButton}
              >
                <Text style={styles.closeButtonText}>×</Text>
              </TouchableOpacity>
              <Text
                style={[
                  styles.productName,
                  {
                    color:
                      selectedTag === item.id_product ? "#1976D2" : "#757575",
                  },
                ]}
              >
                {item.name == "other" ? `${item.price_sell}` : item.name}
              </Text>
              <View style={styles.quantityBadge}>
                <Text style={styles.quantityText}>
                  {quantities[item.id_product] || 1}
                </Text>
              </View>
            </TouchableOpacity>
          </Animated.View>
        ))}
      </ScrollView>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
    marginTop: 20,
    marginBottom: 20,
  },
  scrollView: {
    flexDirection: "row",
  },
  scrollContent: {
    paddingHorizontal: 5,
    gap: 10,
  },
  productPill: {
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 25,
    paddingHorizontal: 15,
    paddingVertical: 10,
    borderWidth: 2,
    minWidth: 80,
  },
  closeButton: {
    backgroundColor: "#F44336",
    borderRadius: 10,
    width: 18,
    height: 18,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 8,
  },
  closeButtonText: {
    color: "white",
    fontSize: 10,
    fontWeight: "bold",
  },
  productName: {
    fontSize: 14,
    fontWeight: "600",
    marginRight: 8,
  },
  quantityBadge: {
    backgroundColor: "#4CAF50",
    borderRadius: 12,
    width: 22,
    height: 22,
    justifyContent: "center",
    alignItems: "center",
  },
  quantityText: {
    color: "white",
    fontSize: 12,
    fontWeight: "bold",
  },
});

export default ProductList;
